module.exports = ".pdf-list li{\r\n    list-style-type: none;\r\n    padding: 5px 0px;\r\n}\r\n.pdf-list li a:hover{\r\n    color: gray;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/Main/other-acts-page/other-acts-page.component.css
// module id = ./src/app/pages/Main/other-acts-page/other-acts-page.component.css
// module chunks = main